import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  const [clickCount, setClickCount] = useState(0);
  const [resetTimeout, setResetTimeout] = useState<NodeJS.Timeout | null>(null);
  const [showEmojis, setShowEmojis] = useState(false);

  const messages = [
    "you are not supposed to be here",
    "still not supposed to be here...",
    "seriously, go away",
    "this is getting awkward",
    "ok fine, you found me 🎉"
  ];

  const emojis = ['🎉', '🎊', '✨', '🌟', '💫', '🎈', '🎁', '🎪'];

  // Calculate derived values
  const currentMessage = messages[Math.min(clickCount, messages.length - 1)];
  const isEasterEggActive = clickCount > 0 && clickCount < messages.length;

  useEffect(() => {
    // Google Analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('config', 'G-FDSLDZ5EWW');
    }
  }, []);



  const handleClick = () => {
    // Clear any pending reset timeout
    if (resetTimeout) {
      clearTimeout(resetTimeout);
      setResetTimeout(null);
    }

    const newCount = clickCount + 1;
    setClickCount(newCount);

    if (newCount < messages.length) {
      // Reset if they stop clicking for 2 seconds
      const timeout = setTimeout(() => {
        setClickCount(0);
      }, 2000);
      setResetTimeout(timeout);
    } else if (newCount === messages.length) {
      // Show emojis
      setShowEmojis(true);

      // Reset after 5 seconds
      setTimeout(() => {
        setClickCount(0);
        setShowEmojis(false);
      }, 5000);
    }
  };

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="space-y-6">
        <header>
          <h1 className="text-xl font-bold uppercase tracking-widest">404</h1>
          <p className="mt-2 text-sm text-gray-600">Page not found</p>
        </header>

        <div className="border border-black p-6 bg-white">
          <div
            className={`text-sm mb-6 cursor-pointer transition-colors ${isEasterEggActive ? 'text-black' : 'text-gray-600'
              }`}
            onClick={handleClick}
          >
            {currentMessage}
          </div>

          <div className="flex gap-4 text-xs font-mono">
            <Link to="/" className="hover:underline">
              [ go home ]
            </Link>
            <Link to="/ls" className="hover:underline text-gray-500">
              [ browse directory ]
            </Link>
          </div>
        </div>

        {showEmojis && (
          <div className="fixed inset-0 pointer-events-none z-50">
            {Array.from({ length: 20 }).map((_, index) => {
              const randomLeft = Math.random() * 100;
              const randomDelay = Math.random() * 0.5;
              const randomEmoji = emojis[Math.floor(Math.random() * emojis.length)];

              return (
                <div
                  key={index}
                  className="absolute animate-float-up text-2xl"
                  style={{
                    left: `${randomLeft}%`,
                    bottom: '-50px',
                    animationDelay: `${randomDelay}s`,
                  }}
                >
                  {randomEmoji}
                </div>
              );
            })}
          </div>
        )}

        <style>{`
          @keyframes float-up {
            from {
              transform: translateY(0) rotate(0deg);
              opacity: 1;
            }
            to {
              transform: translateY(-100vh) rotate(360deg);
              opacity: 0;
            }
          }
          .animate-float-up {
            animation: float-up 3s ease-out forwards;
          }
        `}</style>
      </div>
    </>
  );
};

export default NotFound;
